import request from '@/utils/request'

/**
 * 查询分组列表
 * @param query
 */
export function fetchList(query) {
	return request({
		url: '/api/group/list',
		method: 'post',
		data: query
	})
}

/**
 * 分组多选
 * @param query
 */
export function findAll(query) {
	return request({
		url: '/api/group/all',
		method: 'get',
		data: query
	})
}

/**
 * 新增分组
 * @param param
 */
export function save(param) {
	return request({
		url: '/api/group/save',
		method: 'post',
		data: param
	})
}

/**
 * 修改分组
 * @param param
 */
export function update(param) {
	return request({
		url: '/api/group/update',
		method: 'post',
		data: param
	})
}

/**
 * 删除分组
 * @param param
 */
export function remove(param) {
	return request({
		url: '/api/group/delete/' + param,
		method: 'post'
	})
}

/**
 * 获取单个分组基本资料
 * @param param
 */
export function get(param) {
	return request({
		url: '/api/group/view/' + param,
		method: 'get'
	})
}
